import { render, staticRenderFns } from "./ReportingEntrance.vue?vue&type=template&id=4541bb2f&scoped=true&"
import script from "./ReportingEntrance.vue?vue&type=script&lang=js&"
export * from "./ReportingEntrance.vue?vue&type=script&lang=js&"
import style0 from "./ReportingEntrance.vue?vue&type=style&index=0&id=4541bb2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4541bb2f",
  null
  
)

export default component.exports